import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GamingService {

  private apiUrl = environment.apiUrl;
  newExclusionList: any;

  constructor(private http: HttpClient) { }

  updateExclusionList(selectedItem: any) {
    console.log(selectedItem);
    
    return this.http.put<any>(`${this.apiUrl}update_exclusion_list/${selectedItem.record_id}`, selectedItem)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error('Failed to update exclusion list', err);
          return of(null);
        })
      );
  }

  deleteExclusion(recordId: string): Observable<any> {
    console.log('fgbifhguirgiwgriw')
    return this.http.delete(`${this.apiUrl}/exclusion_list/${recordId}`).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(`Error deleting record with ID ${recordId}`, error);
        return throwError(() => new Error('Failed to delete the record. Please try again later.'));
      })
    );
  }

  gamingExclusionList(pageNo:any) {
    return this.http.get<any[]>(`${this.apiUrl}exclusion_list?page_size=20&page_number=${pageNo}`)
      .pipe(
        catchError((_err: HttpErrorResponse) => {
          console.error('Failed to Gaming Exclusion List')
          return of([]);
        })
      );
  }

  createExclusionList(newExclusionList: any) {
    return this.http.post<any>(`${this.apiUrl}add_exclusion_list`, newExclusionList)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error(`Error deleting record with ID`, error);
          return throwError(() => new Error('Failed to delete the record. Please try again later.'));
        })
      );
  }
  gamingExclusionListCount(){
    return this.http.get<any[]>(`${this.apiUrl}exclusion_counts`)
      .pipe(
        catchError((_err: HttpErrorResponse) => {
          console.error('Failed to Gaming Exclusion List')
          return of([]);
        })
      );
  }
}
